import React, { createContext, useContext, useCallback, useState } from 'react';
import { v4 as uuid } from 'uuid';
import ToastContainer from '../components/ToastContainer';

const ToastContext = createContext({});

const ToastProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addToast = useCallback(
    ({ type, title, description }) => {
      const id = uuid();
      const toast = {
        id,
        title,
        type,
        description,
      };

      setMessages((oldMessages) => [...oldMessages, toast]);
    },
    [setMessages],
  );

  const removeToast = useCallback(
    (id) => {
      setMessages((state) => state.filter((message) => message.id !== id));
    },
    [setMessages],
  );

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      <ToastContainer messages={messages} />
    </ToastContext.Provider>
  );
};

function useToast() {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error('useToast must be within a ToastProvider');
  }

  return context;
}

export { ToastProvider, useToast };
